<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <div class="totals-box pl24 mt20 align-item">
              <div class="flex-row">
                <div class="c111 itemName">{{ form.staffName }}</div>
                <div class="c111 greenLabel" v-if="form.backStatus == 'noReturnRequired'">已领取</div>
                <div class="c111 blueLabel" v-else-if="form.backStatus == 'returned'">已归还</div>
                <div class="c111 backStatusLabel" v-else>待归还</div>
              </div>
          </div>

          <p class="order-title-boxs"><span class="blueBlock"></span><i>借领详情</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">借领状态</div>
              <div class="itemNum" v-if="form.backStatus == 'noReturnRequired'">已领取</div>
              <div class="itemNum" v-else-if="form.backStatus == 'returned'">已归还</div>
              <div class="itemNum" v-else>待归还</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">登记类型</div>
              <div class="itemNum">{{ form.borrowTypeCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">物品名称</div>
              <div class="itemNum">{{ form.thingName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">物品数量</div>
              <div class="itemNum">{{ form.thingCount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">借领日期</div>
              <div class="itemNum">{{ form.borrowTime }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">借领技师</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemRemark">备注</div>
              <div class="itemNum pr16">{{ form.remark || '-' }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">创建时间</div>
              <div class="itemNum">{{ form.createTime }}</div>
            </div>
          </div>
          <!-- <p class="order-title-boxs" v-if="borrowList.length != 0"><span class="blueBlock"></span><i>归还记录</i></p>
          <div class="totals-box mlr24" v-if="borrowList.length != 0">
            <el-row class="deposit-details">
              <el-col :span="4" class="pl10 pl10">归还类型</el-col>
              <el-col :span="4">归还数量</el-col>
              <el-col :span="4">归还日期</el-col>
              <el-col :span="4">归还技师</el-col>
              <el-col :span="4">归还备注</el-col>
              <el-col :span="4" class="tRight pr10">创建时间</el-col>
            </el-row>
            <el-row v-for="(item,index) in borrowList" :key="index" class="mt20">
              <el-col :span="4" class="pl10 color999">{{item.backStatusCn}}</el-col>
              <el-col :span="4" class="color999">{{item.backCount}}</el-col>
              <el-col :span="4" class="color999">{{formatDay(item.backTime)}}</el-col>
              <el-col :span="4" class="color999">{{item.staffName}}</el-col>
              <el-col v-if="item.remark" :span="4" class="color999">{{item.remark}}</el-col>
              <el-col v-if="item.remark == ''" :span="8" class="tRight pr10 color999">{{formatDate(item.createTime)}}</el-col>
              <el-col v-else :span="4" class="tRight pr10 color999">{{formatDate(item.createTime)}}</el-col>
            </el-row>
          </div> -->

          <p class="order-title-boxs" v-if="borrowList.length != 0"><span class="blueBlock"></span><i>归还记录</i></p>
          <div class="totals-box customTable" v-if="borrowList.length != 0">
            <div class="detail plr20">
              <el-table :data="borrowList" input-large header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="backStatusCn" label="归还类型" width="80"></el-table-column>
                <el-table-column prop="backCount" label="归还数量" width="80"></el-table-column>
                <el-table-column label="归还日期" width="100" align="left">
                  <template slot-scope="scope">{{ formatDay(scope.row.backTime)}}</template>
                </el-table-column>
                <el-table-column prop="staffName" label="归还技师" width="80"></el-table-column>
                <el-table-column prop="remark" label="备注" width="auto"></el-table-column>
                <el-table-column label="创建时间" width="160" align="right">
                  <template slot-scope="scope">{{ formatDate(scope.row.createTime)}}</template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="drawer-footer pr24 pb10">
        <div class="btns">
          <el-button @click="back">取消</el-button>
          <el-button v-if="backFlag" type="primary" @click="onSubmitBack">归还</el-button>
        </div>
      </div>
      </div>
    </drawer>

    <staff-set ref="staffSetForm" @staffChange="changePage"></staff-set>
    <borrowBack-set ref="borrowBackForm" @borrowBackChange="borrowBackChange"></borrowBack-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import payDialog from "../../components/pay-dialog";
import staffSet from "../../components/staff-set";
import borrowBackSet from "./borrowBack.vue";
import Dialog from "../../../components/common/dialog.vue";
export default {
  mixins: [minxin],
  components: {
    drawer,
    payDialog,
    staffSet,
    Dialog,
    borrowBackSet
  },
  props: {
      typeCate: {
          type: String,
          default: 'reserve'
      }
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "",
      dialogHide: false,
      form: {
        orderType: ""
      },
      //归还记录
      borrowList: [],

      backFlag:false,
      borrowId:'',
    };
  },
  created() {
    this.init();
  },
  mounted() {
    
  },
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.borrowId = org;
        this.getBorrowBackList(org)
        this.$api.get(this.$url.staffBorrowInfo.detail, {
          borrowId: org
          }).then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
              this.addEditTitle = "物品"+this.form.borrowTypeCn;
              this.backFlag = this.form.backFlag;
              this.form.id = String(this.form.id)
              this.form.borrowTime = this.formatDay(this.form.borrowTime);
              this.form.createTime = this.formatDate(this.form.createTime);
            }
          }).catch(error => {});
      });
    },
    getBorrowBackList (org) {
      console.log(org);
        this.$api.post(this.$url.staffBorrowInfo.borrowBackList, {borrowId: org}).then(ret => {
            if (ret) {
                this.borrowList = ret;
                this.borrowList.map((item) => {
                if (item.backStatus == "returned") {
                  item.backStatusCn = "全部归还";
                }
                if (item.remark == "") {
                  item.remark = "-";
                }
        });
            }
        });
    },
    
    changePage(org) {
      //value
      console.log(org)
      console.log(this.form.itemList)
    },
    handleChange(bool) {
      if (bool) {
        this.addEditShow = false;
      }
    },
    borrowBackChange() {
      this.getBorrowBackList(this.borrowId);
      this.$api.get(this.$url.staffBorrowInfo.detail, {
          borrowId: this.borrowId
          }).then(res => {
            if (res) {
              this.form = res;
              this.addEditTitle = "物品"+this.form.borrowTypeCn;
              this.backFlag = this.form.backFlag;
              this.form.id = String(this.form.id)
              this.form.borrowTime = this.formatDay(this.form.borrowTime);
              this.form.createTime = this.formatDate(this.form.createTime);

              if (!this.backFlag) {
                this.$emit("change", true);
              }
            }
          }).catch(error => {});
    },
    back() {
      localStorage.removeItem("payMobile")
      this.addEditShow = false;
    },
    onSubmitBack() {
      // this.$refs["borrowBackForm"].$emit("set");
      this.$refs["borrowBackForm"].$emit("set", this.form);
    },
  }
};
</script>

<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  .titles-head {
    border-top: 0;
  }
  .deposit-details {
    height: 56px;
    line-height: 56px;
    background: #F7F8FA;
  }

  .backStatusLabel {
    color: #F5A623;
  }
  .blueLabel {
    color: #1276FF;
  }
  .greenLabel {
    color: #62C87F;
  }
}
.dialog-staff-box {
  .body-content {
    .deduct-amount {
      display: flex;
      justify-content: space-between;
      margin: 0 30px;
      font-size: 16px;

      
    }
    .body-title {
      text-align: right;
      color: #2795fd;
      cursor: pointer;
      i {
        margin-right: 9px;
      }
    }
    .boxs {
      margin: 0 29px;
      font-size: 16px;
      .box {
        margin-top: 20px;
        background-color: #f3f3f3;
        border-radius: 4px;
        color: #282828;
        display: flex;
        align-items: center;
        .flex {
          flex: 1;
          margin-right: 42px;
          .staffs-msg {
            padding-top: 20px;
            display: flex;
            justify-content: space-between;
            // align-items: center;
            .img {
              cursor: pointer;
            }
            .staff-name {
              display: flex;
              align-items: center;
            }
            .add-img {
              width: 35px;
              vertical-align: middle;
              position: relative;
              &::before {
                content: "+";
                position: absolute;
                font-size: 24px;
                height: 35px;
                top: 0;
                left: 0;
                width: 35px;
                text-align: center;
              }
            }
            .notStaff {
              position: relative;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              width: 133px;
              height: 33px;
              cursor: pointer;
              display: flex;
              justify-content: center;
              .span {
                left: 45px;
                position: absolute;
                height: 33px;
                display: flex;
                align-items: center;
                &::before {
                  content: "+";
                  font-size: 24px;
                  position: absolute;
                  left: -20px;
                  color: #333;
                  height: 35px;
                  top: 0;
                }
              }
            }
          }
          .deduct-msg {
            padding: 20px 0;
            display: flex;
            justify-content: space-between;
          }
          .label {
            margin-left: 26px;
          }
        }
        .close {
          margin-right: 20px;
          font-size: 25px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>